enum HomeTestIds {
  HOME_CONTENT = 'homeContent',
}

export default HomeTestIds
